import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { COLORS } from '../constants/styles';

const Base = styled.div<{ localStyles: any }>`
    background-color: ${COLORS.white};
    border-radius: 4px;
    box-shadow: 0px 13 20px rgba(0, 0, 0, 0.35);
    ${(props) => (props.localStyles ? props.localStyles : '')};
`;

type TileProps = {
    localStyles: any;
    qaId?: string;
};

const Tile = ({ children, localStyles, qaId }: PropsWithChildren<TileProps>) => (
    <Base localStyles={localStyles} data-qa-id={qaId}>
        {children}
    </Base>
);

export default Tile;
